var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 26 10","width":"26","height":"10"}},[_c('path',{attrs:{"fill":"#EEEEF2","d":"M26 10c-6.39 0-8.748-3.275-12.724-9.843A.324.324 0 0 0 13 0a.324.324 0 0 0-.276.157C8.748 6.725 6.39 10 0 10h26z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }